import { z } from "zod";
import { assessmentSummarySchema } from "./knowledge-assessment.js";

export const assessmentCheckSchema = assessmentSummarySchema.extend({
  revision: z.number().int().positive(),
  topicCompleted: z.boolean(),
  latestAttemptId: z.string().nullable(),
  routeAttemptId: z.string().nullable(),
});
export const assessmentOverviewSchema = z
  .object({
    routeCompleted: z.boolean(),
    checks: z.array(assessmentCheckSchema),
  })
  .strict();
export type AssessmentCheck = z.infer<typeof assessmentCheckSchema>;
export type AssessmentOverview = z.infer<typeof assessmentOverviewSchema>;
